import { createSlice } from '@reduxjs/toolkit';
import { getStressValues } from '../../../rtk-apis/reports/getStressValues';

const initialState = {
  status: '',
  data: null as any,
  msg: '',
  loading: false,
};

const getStressValuesSlice = createSlice({
  name: 'getStressValuesSlice',
  initialState,
  reducers: {
    clearState: state => {
      state.status = '';
      state.data = null;
      state.msg = '';
      state.loading = false;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(getStressValues.pending, state => {
        state.loading = true;
      })
      .addCase(getStressValues.fulfilled, (state, action) => {
        state.loading = false;
        state.status = 'SUCCESS';
        state.data = action?.payload?.data ?? action?.payload;
        state.msg = action?.payload?.message;
      })
      .addCase(getStressValues.rejected, (state, action) => {
        state.loading = false;
        state.status = 'FAILED';
        state.msg = (action?.payload as string) || 'Something went wrong';
      });
  },
});

export const { clearState } = getStressValuesSlice.actions;
export default getStressValuesSlice.reducer;
